define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/view/RefreshController",
	"Apparel",
	"Apparel/ProductTypeProperties"
], function(declare, lang, RefreshController, Apparel, ProductTypeProperties) {

	var _RefreshController = declare(RefreshController, {
		process: function() {
			var dfd = Apparel.refreshStyleImages(this.getNode());
			if (dfd) {
				dfd.then(lang.hitch(this, this._onPublishResponse));
			} else {
				this.inherited(arguments);
			}
		}
	});

	return declare(ProductTypeProperties, {
		productType: "StyleType",

		_actionControllers: {
			ViewRefresh: _RefreshController
		}
	});
});